export enum EllipseName {
  None = 'none',
  Conf95 = '95% confidence',
  Conf85 = '85% confidence',
  Conf50 = '50% confidence',
  Conf99 = '99% confidence',
}
